/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAktResponseEmailAllOfMembersAddresslist
 */
export interface GetAktResponseEmailAllOfMembersAddresslist {
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseEmailAllOfMembersAddresslist
     */
    anr?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseEmailAllOfMembersAddresslist
     */
    description?: string;
}

export function GetAktResponseEmailAllOfMembersAddresslistFromJSON(json: any): GetAktResponseEmailAllOfMembersAddresslist {
    return GetAktResponseEmailAllOfMembersAddresslistFromJSONTyped(json, false);
}

export function GetAktResponseEmailAllOfMembersAddresslistFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAktResponseEmailAllOfMembersAddresslist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'anr': !exists(json, 'anr') ? undefined : json['anr'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function GetAktResponseEmailAllOfMembersAddresslistToJSON(value?: GetAktResponseEmailAllOfMembersAddresslist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'anr': value.anr,
        'description': value.description,
    };
}


